/**
 * 检测专用类
 */
define(function(require) {

    var CDetector = require('cui/util/detector/detector'),
        browser = CDetector.browser;

    // 检查当前URL是否为detach模式
    function isDetachMode() {
        return /detach.jsp$/.test(location.pathname);
    }

    // 参考 http://stackoverflow.com/questions/28766423/detecting-npapi-support-in-chrome-using-javascript
    // 目前修正的逻辑只检查Chrome浏览器, 其他浏览器都认为支持. 后续其他浏览器如果提供不支持方法需要继续修正这个方法
    function isSupportNPAPI() {
        var isJavaAvailable;

        if (browser.name === 'chrome') {
            isJavaAvailable = (function() {
                var javaRegex = /(Java)(\(TM\)| Deployment)/,
                    plugins = navigator.plugins || [], plugin;
                for (plugin in plugins) {
                    if (plugins.hasOwnProperty(plugin) && javaRegex.exec(plugins[plugin].name)) {
                        return true;
                    }
                }

                return false;
            })();

            if (browser.version >= 42 && !isJavaAvailable) {
                return false;
            }
        }

        return true;
    }

    function isIE(version) {
        var currentVersion = (function () {
            var returnVersion = -1;
            var userAgent = navigator.userAgent;
            if (navigator.appName === 'Microsoft Internet Explorer') {
                if (/MSIE ([0-9]{1,}[.0-9]{0,})/.exec(userAgent) !== null) {
                    returnVersion = parseInt(RegExp.$1, 10);
                }
            } else if (navigator.appName === 'Netscape') {
                if (/Trident\/.*rv:([0-9]{1,}[.0-9]{0,})/.exec(userAgent) !== null) {
                    returnVersion = parseInt(RegExp.$1, 10);
                }
            }

            return returnVersion;
        })();

        var isIE = currentVersion > 0;
        /**
         * 支持 IE6 ~ 11 的版本检测：
         * '6+'： 表示检测是否为 IE6 以上
         * '11'：表示检测是否为 IE11
         * '8-'：表示检测是否为 IE8 以下
         */
        var operations = /^(1[0-1]|[6-9])(\+|-)?$/.exec(version);

        if (version === void 0 || operations === null || !isIE) {
            // 若没有传 version 或 version 不符合规则或本身不是 IE，则只判断是否是 IE 浏览器即可
            return isIE;
        }

        var versionNumber = parseInt(operations[1], 10);
        var versionOperator = operations[2];
        switch (versionOperator) {
        case '+':
            return currentVersion >= versionNumber;
        case '-':
            return currentVersion <= versionNumber;
        case void 0:
            return currentVersion === versionNumber;
        default:
            return currentVersion === versionNumber;
        }
    }

    function isLowerIE11() {
        return isIE() && browser.version < 11;
    }

    function isClipboardSupport() {
        if (browser.name === 'ie') {
            return (browser.version >= 9) ? true : (window.clipboardData ? 'oldie' : false);
        } else {
            return (browser.name === 'chrome' && browser.version >= 42)
                   || (browser.name === 'firefox' && browser.version >= 41)
                   || (browser.name === 'opera' && browser.version >= 29);
        }
    }

    function supportAjaxUpload() {
        var supportFileAPI = (function() {
            var node = document.createElement('INPUT');
            node.type = 'file';
            return 'files' in node;
        })();

        var supportFormData = (function() {
            return !!window.FormData;
        })();

        return supportFileAPI && supportFormData;
    }

    function supportBlobURL() {
        return !!window.URL && window.URL.createObjectURL;
    }

    return {
        isDetachMode: isDetachMode,
        isSupportNPAPI: isSupportNPAPI,
        isClipboardSupport: isClipboardSupport,
        isIE: isIE,
        isLowerIE11: isLowerIE11,
        supportAjaxUpload: supportAjaxUpload,
        supportBlobURL: supportBlobURL,
        device: CDetector.device,
        os: CDetector.os,
        engine: CDetector.engine,
        browser: browser
    }

});





/*****************
 ** WEBPACK FOOTER
 ** ./web.modules/coremail.XT5/src/XT5/@project.revision@/script/util/detector.js
 ** module id = 50
 ** module chunks = 13 14
 **/